<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Webinar Information</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                        </div> 
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="local"
                            :totalRows="totalRecords"
                            :pagination-options="{
                                enabled: true,
                                dropdownAllowAll: false,
                                perPageDropdown: [10, 20, 50, 100, 200],
                                perPage: serverParams.perPage
                            }"
                            :rows="rows" 
                            :columns="columns">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm" @click="editMember(props.row)" class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from 'vue-json-to-csv'
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue';
Vue.component('vue-json-to-csv', VueJsonToCsv)
Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            json_data: [
                {
                    'name': 'Tony Peña',
                    'city': 'New York',
                    'country': 'United States',
                    'birthdate': '1978-03-15',
                    'phone': {
                        'mobile': '1-541-754-3010',
                        'landline': '(541) 754-3010'
                    }
                },
                {
                    'name': 'Thessaloniki',
                    'city': 'Athens',
                    'country': 'Greece',
                    'birthdate': '1987-11-23',
                    'phone': {
                        'mobile': '+1 855 275 5071',
                        'landline': '(2741) 2621-244'
                    }
                }
            ],
            serverParams: {
                sort: [
                    {
                        field: 'id', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Module',
                    field: 'moduleNumber',
                    sortable: false, // Enable sorting for the Module column

                },
                {
                    label: 'Week',
                    field: 'WeekNumber',
                    sortable: false,
                },
                {
                    label: 'Webinar VimeoLink',
                    field: "WebinarVimeoLink",
                    sortable: false,
                },
                {
                    label: 'WebinarDate',
                    field: "WebinarDate",
                    sortable: false,
                    formatFn: this.formatDate
                },
                {
                    label: 'WebinarLink',
                    field: "WebinarLink",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                }
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            CSVData: []
        };
    },
    methods: {
        editMember(webinarinfo) {
            this.$router.push({ name: 'edit_webinarinfo', params: { id: webinarinfo.WebinarID, webinarinfo: webinarinfo } });
        },
        loadItems() {
            this.isLoading = true;
            API.getWebinarInfo(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    // console.log(data.totalRecords);
                    // this.rows.forEach(q => {
                    //     const data = {
                    //         spot_id: q.user.id,
                    //         spot_status: (q.user.MemberStatus === 'Active') ? true : false,
                    //     }
                    //     this.spots.push(data);
                    // });
                    this.isLoading = false;
                }, err => {
                    this.isLoading = false;
                })
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        changeStatus(spot_id, event) {
            const data = {
                id: spot_id,
                status: (event.value === true) ? 'Active' : 'Inactive',
            }
            API.updateMemberStatus(data,
                data => {
                    if (data.status === 200) {
                        this.$showNotification(data, "success")
                    }
                }, err => {
                    console.log(err);
                    this.$showNotification({ message: 'Failed system error' }, "error")
                })
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MMM DD, yyyy')
            }
        },
        onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },

    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>
